// @flow
import { getCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_RECENT_LIST_PRODUCTS: `${environment.apiUrl}/products/recent`,
  GET_POPULAR_LIST_PRODUCTS: `${environment.apiUrl}/products/popular`,
  GET_DEALS: `${environment.apiUrl}/product-deal/list`,
  GET_FEATURED_PRODUCTS: `${environment.apiUrl}/products/featured`,
  GET_STORES_DEALS: `${environment.apiUrl}/wishlist/:userId/:nameSlug`,
});

export const getRecentListProductsApi = getCreator(fetch, endpoints.GET_RECENT_LIST_PRODUCTS);
export const getPopularListProductsApi = getCreator(fetch, endpoints.GET_POPULAR_LIST_PRODUCTS);
export const getDealsApi = getCreator(fetch, endpoints.GET_DEALS);
export const getFeaturedProductsApi = getCreator(fetch, endpoints.GET_FEATURED_PRODUCTS);
export const getStoresDealsApi = getCreator(fetch, endpoints.GET_STORES_DEALS);



// WEBPACK FOOTER //
// ./src/modules/special-products/api.js